/**
 * User-requested YouTube playback. No third-party thumbnail or iframe request
 * occurs until Play. Playback is a request for this embed, not a global consent
 * grant. youtube-nocookie still contacts Google; the adjacent notice says so.
 */
(function () {
  'use strict';
  if (window.__hfsYouTubeFacade) return;
  window.__hfsYouTubeFacade = true;
  var ID_RX = /^[A-Za-z0-9_-]{11}$/;
  var previousMarketing = false;

  function stop(wrap, restoreFocus) {
    var iframe = wrap.querySelector('iframe');
    if (iframe) {
      iframe.src = 'about:blank';
      iframe.remove();
    }
    var play = wrap.querySelector('.hfs-yt__btn');
    var stopButton = wrap.parentElement.querySelector('.hfs-yt__stop');
    if (stopButton) stopButton.hidden = true;
    if (play) {
      play.hidden = false;
      if (restoreFocus) play.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var stopButton = target.closest('.hfs-yt__stop');
    if (stopButton) {
      var player = stopButton.closest('.hfs-yt-player').querySelector('.hfs-yt');
      if (player) stop(player, true);
      return;
    }
    var button = target.closest('.hfs-yt__btn');
    if (!button) return;
    var wrap = button.closest('.hfs-yt');
    var id = wrap && wrap.getAttribute('data-hfs-yt');
    if (!ID_RX.test(id || '') || wrap.querySelector('iframe')) return;
    // HFS (audit 2026-10-01, C02): one video plays at a time; starting another stops the one already playing.
    document.querySelectorAll('.hfs-yt[data-hfs-yt]').forEach(function (other) { if (other !== wrap) stop(other, false); });
    var iframe = document.createElement('iframe');
    iframe.title = wrap.getAttribute('data-hfs-yt-title') || 'YouTube video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    // Send only the origin cross-site, never a condition-bearing path or query.
    iframe.setAttribute('referrerpolicy', 'strict-origin');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    button.hidden = true;
    wrap.appendChild(iframe);
    wrap.parentElement.querySelector('.hfs-yt__stop').hidden = false;
    iframe.focus();
  });

  if (window.HFSConsent) window.HFSConsent.onChange(function (state) {
    if (previousMarketing && !state.marketing) {
      document.querySelectorAll('.hfs-yt[data-hfs-yt]').forEach(function (wrap) {
        stop(wrap, wrap.contains(document.activeElement));
      });
    }
    previousMarketing = state.marketing;
  });
})();
